<template>
  <div>
    <HeaderComponent :menu-id="3"></HeaderComponent>
    <div style="background-color: #FFFAF4;">
      <div class="peifu-container" style="padding-bottom: 0px;">
        <!-- 标题 -->
        <div class="title-ty" style="padding-bottom: 50px;">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>机制币送评</span>赔付标准</div>
        </div>
        <div class="peifu-box" style="padding-bottom: 0px;">
          <div class="tixing"><span>特别提醒:</span>您一经选择水石评级的服务，即视为接受本承诺全部条款，若您不接受本承诺全部或部分条款，请及时向我们作出说明。</div>
          <p class="p-ty">1. 水石评级“一币一估值，全额赔付”是古钱币赔付标准，不适用于机制币评级。机制币赔付，按照该枚钱币对应的估值档位，参考公允市场估值进行赔付；</p>
          <p class="p-ty">2. 假币入盒赔付：原盒完好复检确认为赝品，按送评时公允市价全额赔付，上限不超过该档位收费对应的最高估值；也可协商更换一枚同品相真品；</p>
          <p class="p-ty">3. 漏标瑕疵赔付：复检发现遗漏关键瑕疵代码，按实际缴纳评级费3倍赔付；</p>
          <p class="p-ty">4. 本标准的最终解释权归水石评级所有。</p>
        </div>
      </div>
      <div class="peifu-no">
        <div class="peifu-box">
          <div class="tixing">不予赔付情形</div>
          <p class="p-ty" style="margin-top: 10px;">1.客户自行砸盒的钱币；</p>
          <p class="p-ty">2.改动币面、修补钱币后再压盒封装的钱币。</p>
        </div>
      </div>
    </div>
    
    <!-- <img src="@/assets/image/peifu-yinyuan.jpg" alt="" style="width: 100%;"> -->
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
  .peifu-no{
    padding-top: 50px;
    height: 450px;
    width: 100%;
    background-image: url('@/assets/image/huise-bottom-ty.png');
    background-size: 100%;
    background-repeat: no-repeat;
  }
</style>